export default "__VITE_ASSET__zmhPBCpu__"